import styled from 'astroturf/react';
import Button from 'src/components/Button';

const Title = styled('span')`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--ph-heading-two);
`;

const Subtitle = styled('span')`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--ph-heading-four);
  margin: 20px 0;
`;

const Text = styled('span')`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 15px 0;
  white-space: pre-line;
`;

const ActionButton = Button;

const ActionButtonsWrapper = styled('div')`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  user-select: none;
`;

export default {
  ActionButton,
  ActionButtonsWrapper,
  Subtitle,
  Text,
  Title,
};
